export const FREE_PRICING_PLAN_IDS = [6, 18];

export const isFreePricingPlanId = (pricingPlanId?: number | null) => {
    return FREE_PRICING_PLAN_IDS.includes(pricingPlanId || 0);
};
